export default {
  fetching: (state) => state.fetching,
  ssoEnabled: state => state.sso.enabled,
  ssoUrl: state => state.sso.url
}
